import createPermission from 'permissions/createPermission'

export default createPermission('mmi')
